<template>
  <!-- 选择用户 -->
  <el-dialog class="h-select-user" :title="title" :visible.sync="visible">
    <el-tabs slot="title" v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="部门员工" name="1">
        <div class="user-content">
          <div class="selected-department">
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item>
                <i class="el-icon-office-building" style="font-weight:bold"></i>
                <span style="font-weight:bold">{{orgName}}</span>
              </el-breadcrumb-item>
              <el-breadcrumb-item v-for="(item,index) in curDepartment" :key="index">{{item}}</el-breadcrumb-item>
            </el-breadcrumb>
          </div>
          <div class="select-user-view">
            <div class="department-view">
              <el-tree ref="userOrgTree" :highlight-current="true" :props="orgTreeProps" node-key="id" lazy :load="loadNode" :expand-on-click-node="false" :default-expand-all="false" @node-click="handleNodeClick" class="el-tree-style">
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <span>{{ node.label }}</span>
                </span>
              </el-tree>
            </div>
            <div class="user-view">
              <el-table ref="selectUserTable" :data="tableData" border height="100%" @selection-change="handleSelectionChange" @row-click='tableRowClick' v-loading="loading.lock" :element-loading-text="loading.text" :element-loading-spinner="loading.spinner" :element-loading-background="loading.background">
                <el-table-column align="center" type="selection" width="55">
                </el-table-column>
                <el-table-column prop="username" label="账号" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column prop="name" label="姓名" show-overflow-tooltip align="center"></el-table-column>
                <el-table-column prop="phone" label="手机" show-overflow-tooltip align="center"></el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane label="搜索用户" name="2">
        <div class="user-content">
          <div class="search-view">
            <el-input placeholder="请输入关键字" v-model="keywords" class="search-view-input" clearable>
              <el-button slot="append" style="font-size:20px;padding:10px 20px;" icon="el-icon-search" @click="getUserByKeywords"></el-button>
            </el-input>
          </div>
          <div class="user-view2">
            <el-table ref="selectUserTable2" :data="tableData2" border height="100%" @selection-change="handleSelectionChange2" @row-click="tableRowClick2" v-loading="loading.lock" :element-loading-text="loading.text" :element-loading-spinner="loading.spinner" :element-loading-background="loading.background">
              <el-table-column align="center" type="selection" width="55">
              </el-table-column>
              <el-table-column prop="username" label="账号" show-overflow-tooltip align="center"></el-table-column>
              <el-table-column prop="name" label="姓名" show-overflow-tooltip align="center"></el-table-column>
              <el-table-column prop="phone" label="手机" show-overflow-tooltip align="center"></el-table-column>
            </el-table>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <span slot="footer" class="dialog-footer">
      <slot></slot>
      <el-button class="dialog-footer-btn" type="primary" @click="visible = false" :disabled="disabled" plain>
        取消
      </el-button>
      <el-button class="dialog-footer-btn" type="primary" @click="submit()" :disabled="disabled" style="background-color: #084FF7;">
        确定
      </el-button>

    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      loading: { lock: false, text: '拼命加载中', spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.3)' },
      refName: '',
      visible: false,
      activeName: '1',
      orgName: '',
      orgTreeProps: { children: 'subOrgList', label: 'deptName', isLeaf: 'leaf' },
      curDepartmentNode: {}, //当前选择节点
      curDepartment: [], //当前选中的部门
      tableData: [], //当前部门下的成员列表
      tableData2: [],
      celectedUser: [],
      celectedUser2: [],
      keywords: '',
      disabled: false,
    }
  },
  props: {
    // 标题
    title: {
      type: String,
      default: '选择用户',
    },
    getCurrentUserOrgNameApi: {
      type: String,
      default: 'getCurrentUserOrgName',
    },
  },
  created() {
    console.log('this1', this)
    this.refName = 'hSelectUser' + this._uid
  },
  watch: {
    visible(val) {
      if (val) {
        this.init()
      }
    },
    curDepartmentNode(val) {
      let arr = []
      let initDepartment = function (node) {
        if (node.data) {
          arr.unshift(node.data.deptName)
        }
        if (node.parent) {
          initDepartment(node.parent)
        }
      }
      if (val) {
        initDepartment(val)
      }
      this.curDepartment = arr
      this.getUserByDepartment()
    },
    activeName() {
      this.$nextTick(() => {
        // this.$refs.selectUserTable.doLayout()
        // this.$refs.selectUserTable2.doLayout()
      })
    },
  },
  methods: {
    // 初始化
    init() {
      if (!this.orgName) {
        this.getOrgName()
      }
    },
    showLoading() {
      this.loading.lock = true
    },
    hideLoading() {
      this.loading.lock = false
    },
    open() {
      this.visible = true
    },
    close() {
      this.visible = false
    },
    handleClick(tab, event) {
      console.log(tab.index)
    },
    getOrgName() {
      let data = {}
      this.$API[this.getCurrentUserOrgNameApi](data).then(
        (res) => {
          this.orgName = res
        },
        (err) => {
          console.log('############orgname', err)
        }
      )
    },
    //节点懒加载
    loadNode(node, resolve) {
      this.node_had = node //将node旧状态存起来
      this.resolve_had = resolve //把旧状态的resolve存起来
      var params = { supDeptCode: '' }
      if (node.data != undefined) {
        params.supDeptCode = node.data.deptCode
      }
      this.$API.getDepartmentList(params).then(
        (res) => {
          resolve(res)
        },
        (err) => {
          console.log('获取组织树列表', err)
        }
      )
    },
    //增删改后手动调用此方法，手动更新视图
    refreshData() {
      // console.log('################refresh')
      this.node_had.childNodes = [] //把存起来的node的子节点清空，不然会界面会出现重复树！
      this.loadNode(this.node_had, this.resolve_had) //再次执行懒加载的方法
    },
    //点击事件按，点击小箭头不触发此事件
    handleNodeClick(data, node) {
      // console.log('#########节点被点击data', data)
      // console.log('#########节点被点击node', node)
      this.curDepartmentNode = node
    },
    // 根据部门查询用户
    getUserByDepartment() {
      let data = {}
      data.dept_id = this.curDepartmentNode.data.id
      this.showLoading()
      this.$API.getDepartmentMemberList(data).then(
        (res) => {
          this.tableData = res
          this.hideLoading()
        },
        (err) => {
          this.hideLoading()
        }
      )
    },
    // 根据关键字查询用户
    getUserByKeywords() {
      this.tableData2 = [
        { id: 1, username: '123', name: '张三', phone: '18888888888' },
        { id: 1, username: '123', name: '张三', phone: '18888888888' },
        { id: 1, username: '123', name: '张三', phone: '18888888888' },
        { id: 1, username: '123', name: '张三', phone: '18888888888' },
      ]
    },
    // table选中项变化
    handleSelectionChange(e) {
      this.celectedUser = e
    },
    // table选中项变化
    handleSelectionChange2(e) {
      this.celectedUser2 = e
    },
    tableRowClick(row) {
      this.$refs.selectUserTable.toggleRowSelection(row)
    },
    tableRowClick2(row) {
      this.$refs.selectUserTable2.toggleRowSelection(row)
    },
    // 提交
    submit() {
      let userList = []
      let userIds = []
      if (this.activeName == '1') {
        userList = this.celectedUser
        for (let i = 0; i < this.celectedUser.length; i++) {
          userIds.push(this.celectedUser[i].id)
        }
      } else {
        userList = this.celectedUser2
        for (let i = 0; i < this.celectedUser2.length; i++) {
          userIds.push(this.celectedUser2[i].id)
        }
      }
      this.$emit('change', userList, userIds)
    },
  },
  mounted() {},
}
</script>

<style scoped lang="stylus">
.h-select-user
  >>>.el-dialog__title
    padding-left 20px
    border-left 4px solid #084ff7
  >>>.el-tabs__header
    margin-bottom 0
  >>>.el-tree-node__expand-icon
    font-size 14px
    width 26px
    height 26px
    line-height 26px
    text-align center
    /* color: #262626; */
  >>>.el-tabs__item
    font-size 16px
  >>>.el-tabs__item.is-active
    color #084ff7
  >>>.el-tabs__item:hover
    color #084ff7
  >>>.el-tabs__active-bar
    background-color #084ff7
  >>>.el-dialog__body
    height 0
    padding 0
  >>>.el-dialog__footer
    border-top 1px solid #E4E7ED
    padding 20px
.user-content
  height 50vh
  // border-left 1px solid #E4E7ED
  // border-right 1px solid #E4E7ED
  // border-bottom 1px solid #E4E7ED
  padding 20px
  display flex
  flex-direction column
  .selected-department
    margin-bottom 20px
  .custom-tree-node
    font-size 14px
  .select-user-view
    flex 1
    display flex
    flex-direction row
    height calc(100% - 34px)
    .department-view
      flex 1
      // border-right 1px solid #cdcdcd
      overflow auto
    .user-view
      flex 2
      padding-left 20px
      // height 100%
  .search-view
    height 60px
    display flex
    flex-direction row
    justify-content flex-start
    align-items center
    margin-bottom 20px
    .search-view-input
      width 30%
      >>>.el-input__inner:focus
        border 1px solid #DCDFE6
      >>>.el-input-group__append
        border-radius 0 5px 5px 0
        border-color #084ff7
    button
      background-color #084ff7
      color #fff
      border-radius 0 3px 3px 0
  .user-view2
    height calc(100% - 80px)
</style>



// WEBPACK FOOTER //
// src/components/parts/hSelectUsercopy.vue